import { MutableRefObject, useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';
import { roundFloat, transformToBob } from '@/utils/common';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

export default function Mowing() {
    const { t } = useLang('bladeroboticlawnmower');
    const videoAutoCarRef = useRef<MutableRefObject<any>>(null);
    const [sources, setSources] = useState<string[] | null>(null);

    useEffect(() => {
        const video: any = videoAutoCarRef.current;
        AniContainer.create({
            asyncFromTo: [
                ['.mowing-ani-bg', { opacity: 0 }, { opacity: 1 }, 0.4],
                ['.mowing-ani-video', { opacity: 0 }, { opacity: 1 }, 1],
                ['.mowing-ani-01', { opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 1],
                ['.mowing-ani-01', { opacity: 1, y: 0 }, { opacity: 0, y: -50 }, 1],
                ['.mowing-ani-02', { opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 1],
                ['.mowing-ani-02', { opacity: 1, y: 0 }, { opacity: 0, y: -50 }, 1],
                ['.mowing-ani-03', { opacity: 0, y: 50 }, { opacity: 1, y: 0 }, 1],
                ['.mowing-ani-03', { opacity: 1, y: 0 }, { opacity: 1, y: 0 }, 1],
            ],
            asyncTimeLine: [0, 0.4, 2.2, 3.6, 4.6, 6.1, 7.2, 8.9],
            triggerElement: '.mowing-sec-01',
            triggerHook: 0,
            offset: 0,
            duration: '200%',
            onProcess: (process: number) => {
                if (video) {
                    // 0 ~ 1
                    // 实际 0.32 ~ 1
                    let processA = (1 / (1 - 0.08)) * (process - 0.08);
                    // 实际 0 ~ 0.9
                    // let processA = process * 1.1;
                    processA = processA < 0 ? 0 : processA;
                    processA = processA > 1 ? 1 : processA;

                    const duration: number = video?.current?.duration;
                    const currentTime = roundFloat(duration * processA, 2) || 0;
                    video?.setCurrentTime(currentTime);
                }
            },
            onLazyLoad: async () => {
                try {
                    const blobUrl = await transformToBob(
                        'https://websiteoss.ecoflow.com/upload/video/1745308976830/0422-%E7%88%86%E7%82%B8%E5%9B%BE%E8%A7%86%E9%A2%91_1.mp4',
                        'https://websiteoss.ecoflow.com/upload/video/1745308976830/0422-%E7%88%86%E7%82%B8%E5%9B%BE%E8%A7%86%E9%A2%91_1.mp4',
                        // handleDynamicPath('/video/blade/detail/pc/mowing_01.mp4'),
                        // handleDynamicPath('/video/blade/detail/pc/mowing_01.webm'),
                    );
                    if (video) {
                        video.current.src = blobUrl;
                    }
                } catch (e) {
                    setSources(['/video/blade/detail/pc/mowing_01.webm', '/video/blade/detail/pc/mowing_01.mp4']);
                }
            },
            lazyHook: 4.5,
        });
    }, []);

    return (
        <div className={css['mod-mowing']}>
            <div className="mowing-sec-01">
                <div id="mowing" className="point"></div>
                <div className="sticky-box">
                    <div className="mask-bg mowing-ani-bg"></div>
                    <div className="video-box mowing-ani-video">
                        <EFVideo ref={videoAutoCarRef} className="video" autoPlay={false} loop={false} sources={sources} />
                    </div>
                    <div className="box-center">
                        <p className="mowing-title mowing-ani-01">{t('detail.xvision_title1')}</p>
                    </div>
                    <div className="mowing-content">
                        <div className="mowing-ani-02">
                            <p className="mowing-sec-title">{t('detail.xvision_title2')}</p>
                            <p className="mowing-sec-desc">{t('detail.xvision_desc2')}</p>
                        </div>
                    </div>
                    <div className="mowing-content">
                        <div className="mowing-ani-03">
                            <p className="mowing-sec-title">{t('detail.xvision_title3')}</p>
                            <p className="mowing-sec-desc">{t('detail.xvision_desc3')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
